import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { EncartPackProduitsTitreTexteLogos } from '@components/encart-pack-produits-titre-texte-logos/models';
import { ImageComponent } from '@shared/components/image';
import { TitleComponent } from '@shared/components/title';
import { HandleHtmlLinksDirective } from '@shared/directives';

@Component({
  selector: 'app-encart-pack-produits-titre-texte-logos',
  imports: [TitleComponent, HandleHtmlLinksDirective, ImageComponent],
  templateUrl: './encart-pack-produits-titre-texte-logos.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EncartPackProduitsTitreTexteLogosComponent extends AbstractDynamicComponent<EncartPackProduitsTitreTexteLogos> {}
